import React from "react";
import { Link } from "react-router-dom";
import { ArrowBackIcon } from "./Icons";

// Shared header layout. The app supplies its live notification and account controls.
export default function AppHeader({ backgroundColor = "black", showBackButton = false, onBack, children }) {
  return (
    <header className="w-full h-12" style={{ backgroundColor }}>
      <div className="h-full mx-auto w-full max-w-5xl px-1 sm:px-2 relative grid grid-cols-[auto,minmax(0,1fr),auto] justify-center items-center">
        <div className="h-full grid items-center">
          {showBackButton && (
            <button type="button" aria-label="Go back" onClick={onBack} className="rounded-full cursor-pointer p-1 ml-3">
              <ArrowBackIcon color="white" size={28} />
            </button>
          )}
        </div>
        <Link to="/" className="min-w-0 justify-self-start px-1">
          <img className="max-h-9 sm:max-h-10 max-w-[150px] sm:max-w-none py-[0.35rem] mx-auto" src={process.env.PUBLIC_URL + "/img/mcc-logo-transparent.png"} alt="My Challenge Canada Logo" />
        </Link>
        <div className="flex h-full items-center justify-end shrink-0">{children}</div>
      </div>
    </header>
  );
}
